<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>


<div class="height-100-percent">
  <!--Design Pages-->
  @if (this.Mode === 'design') {
    <div class="flex-row-top-right">
      <div class="fill-remaining-space">
        <mat-form-field appearance="outline"
          [floatLabel]="'always'">
          @if (this.ShowLabel) {
            <mat-label
            class="design-mode-field-label">{{this.DisplayName}}</mat-label>
          }
          <input matInput disabled />
        </mat-form-field>
      </div>
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
  }

  <!--Preview and Form Instance Pages-->
  @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
    <div class="flex-row-top-right height-100-percent">
      <div class="fill-remaining-space height-100-percent">
        @if ((this.ControlType === 'Reactive Forms')) {
          @if (this.FormControl !== null) {
            <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
              <!-- Display label integrated into the field if the field is not in the Grid -->
              @if (this.ShowLabel && !FieldIsInGrid) {
                <mat-label
                class="field-label">{{this.DisplayName}}</mat-label>
              }
              @if (!this.UseGridSpecificStyling) {
                <!--outside grid-->
                <input matInput
                  type="text"
                  id="{{this.MatInputId}}"
                  [readonly]="this.ReadOnly"
                  class="null-tooltip-mat-input"
                  [formControl]="this.FormControl"
                  (blur)="this.handleOnBlur()"
                  (focus)="this.handleOnFocus($event)" />
                }
                @if (this.UseGridSpecificStyling) {
                  <!--inside grid-->
                  <input #gridOnlyTextArea
                    matInput
                    [readonly]="this.ReadOnly"
                    class="height-100-percent"
                    [formControl]="this.FormControl"
                    (blur)="this.handleOnBlur()"
                    (focus)="this.handleOnFocus($event)" />
                  }
                </mat-form-field>
              }
            }
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
    </div>
